import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { VaNavItemComponent } from './nav-item.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [CommonModule, MatButtonModule, MatIconModule, RouterModule],
  declarations: [VaNavItemComponent],
  exports: [VaNavItemComponent],
})
export class VaNavItemModule {}
